import { useTranslation } from "../../core/translation.core";

const  NoRecordDisplay = () => {

  const { t, msg } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center h-80">
      <span className="text-center text-2xl my-10" >{t(msg.general.noRecordFound)} </span>
    </div>
  )
}

export default NoRecordDisplay;